import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { IConnectedApplicationType } from '../types/ConnectedApplicationType';
import { CreateConnectedApplicationType } from './CreateConnectedApplication';
import { API_VERSION, EAS_PATH } from './RestApiConstants';


function CreateConnectedApplicationConfigEas(): JsonRestApiRequestConfig {
  return {
    restApiVersion: `${API_VERSION}`,
    httpMethod: 'POST',
    endpoint: `${EAS_PATH}`,
    serverWideRequest: false
  };
}

export type CreateEasConnectedApplicationType = Omit<IConnectedApplicationType, 'clientId' | 'createdAt'>;
export interface CreateEasConnectedApplicationParams {
  externalAuthorizationServer: CreateConnectedApplicationType;
}

export interface CreateEasConnectedApplicationResult {
  externalAuthorizationServer: CreateConnectedApplicationType;
}

export interface CreateEasConnectedApplicationError {
  summary: string;
  detail: string;
  code: string;
}

export function callCreateConnectedApplicationEas(request: CreateEasConnectedApplicationParams): Promise<CreateEasConnectedApplicationResult> {
  return makeJsonRestApiRequest<CreateEasConnectedApplicationParams, CreateEasConnectedApplicationResult>({
    config: CreateConnectedApplicationConfigEas(),
    request: request,
  });
}

